module.exports = __webpack_public_path__ + "img/vroom.im.png";